import { j as p } from "./jsx-runtime-944c88e2.js";
import * as g from "react";
import { createContext as K, useContext as w, useState as D, useCallback as q } from "react";
import { a as U, b as V, c as X, F as z } from "./FormElement-65f04cfd.js";
import { L as J } from "./Label-079ad7bc.js";
import { p as c, g as Q, c as F } from "./index-efd35e77.js";
import { v as B, c as R, p as A } from "./package-metadata-3dcf116a.js";
var T = function(e) {
  B(A);
  var t = R({
    "k-form-error": !0,
    "k-text-start": e.direction === "start",
    "k-text-end": e.direction === "end"
  }, e.className);
  return g.createElement("div", { id: e.id, role: "alert", style: e.style, className: t }, e.children);
};
T.propTypes = {
  id: c.string,
  direction: c.oneOf(["start", "end"]),
  children: c.oneOfType([
    c.element,
    c.node
  ]),
  style: c.object,
  className: c.string
};
T.defaultProps = {
  direction: "start"
};
T.displayName = "KendoReactError";
var C = function(e) {
  B(A);
  var t = R({
    "k-form-hint": !0,
    "k-text-start": e.direction === "start",
    "k-text-end": e.direction === "end",
    "k-text-disabled": e.editorDisabled === !0
  }, e.className);
  return g.createElement("div", { id: e.id, style: e.style, className: t }, e.children);
};
C.propTypes = {
  id: c.string,
  direction: c.oneOf(["start", "end"]),
  children: c.oneOfType([
    c.element,
    c.node
  ]),
  style: c.object,
  className: c.string,
  editorDisabled: c.bool
};
C.defaultProps = {
  direction: "start"
};
C.displayName = "KendoReactHint";
var j = globalThis && globalThis.__assign || function() {
  return j = Object.assign || function(e) {
    for (var t, a = 1, r = arguments.length; a < r; a++) {
      t = arguments[a];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, j.apply(this, arguments);
}, Y = globalThis && globalThis.__rest || function(e, t) {
  var a = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (a[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (a[r[i]] = e[r[i]]);
  return a;
}, H = function(e) {
  var t = e.name, a = e.component, r = e.validator, i = e.children, f = e.onChange, d = Y(e, ["name", "component", "validator", "children", "onChange"]), n = g.useContext(U), s = n ? n.id : "";
  g.useEffect(function() {
    if (n) {
      var u = n.registerField(t, r);
      return u;
    }
  }, [t, s, r]);
  var v = g.useCallback(function(u) {
    var E = u && (u.value !== void 0 ? u.value : u.target ? u.target.value : u.target);
    n.onChange(t, { value: E }), f && f.call(void 0, u);
  }, [t, s, f]), m = g.useCallback(function(u) {
    return n.onChange(t, { value: u.target.value });
  }, [t, s]), l = g.useCallback(function() {
    return n.onBlur(t);
  }, [t, s]), h = g.useCallback(function() {
    return n.onFocus(t);
  }, [t, s]);
  if (!n)
    return null;
  var y = n.valueGetter(t);
  return typeof a == "string" ? g.createElement(a, j({ onChange: m, onBlur: l, onFocus: h, value: y, children: i }, d)) : g.createElement(a, j(j({ children: i }, d), {
    // input
    onChange: v,
    onBlur: l,
    onFocus: h,
    value: y,
    // meta
    validationMessage: n.errors[t],
    touched: n.touched[t],
    modified: n.modified[t],
    visited: n.visited[t],
    // Our `valid` implementation requires double submit to show html5 validation errors,
    // however it's NOT recommended to show html5 validation errors at all as:
    // - There is no standard way to change validation look and feel with CSS.
    // - Look different in each browser / OS
    // - You can have a page in one language but an error message displayed in another language (not localizable)
    valid: !(n.errors[t] && n.touched[t]),
    name: t
  }));
};
H.displayName = "KendoReactField";
var Z = "Expected a function", L = 0 / 0, ee = "[object Symbol]", te = /^\s+|\s+$/g, re = /^[-+]0x[0-9a-f]+$/i, ne = /^0b[01]+$/i, ae = /^0o[0-7]+$/i, ie = parseInt, oe = typeof F == "object" && F && F.Object === Object && F, se = typeof self == "object" && self && self.Object === Object && self, ce = oe || se || Function("return this")(), le = Object.prototype, ue = le.toString, de = Math.max, fe = Math.min, N = function() {
  return ce.Date.now();
};
function me(e, t, a) {
  var r, i, f, d, n, s, v = 0, m = !1, l = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(Z);
  t = S(t) || 0, I(a) && (m = !!a.leading, l = "maxWait" in a, f = l ? de(S(a.maxWait) || 0, t) : f, h = "trailing" in a ? !!a.trailing : h);
  function y(o) {
    var b = r, x = i;
    return r = i = void 0, v = o, d = e.apply(x, b), d;
  }
  function u(o) {
    return v = o, n = setTimeout(O, t), m ? y(o) : d;
  }
  function E(o) {
    var b = o - s, x = o - v, P = t - b;
    return l ? fe(P, f - x) : P;
  }
  function $(o) {
    var b = o - s, x = o - v;
    return s === void 0 || b >= t || b < 0 || l && x >= f;
  }
  function O() {
    var o = N();
    if ($(o))
      return _(o);
    n = setTimeout(O, E(o));
  }
  function _(o) {
    return n = void 0, h && r ? y(o) : (r = i = void 0, d);
  }
  function G() {
    n !== void 0 && clearTimeout(n), v = 0, r = s = i = n = void 0;
  }
  function M() {
    return n === void 0 ? d : _(N());
  }
  function k() {
    var o = N(), b = $(o);
    if (r = arguments, i = this, s = o, b) {
      if (n === void 0)
        return u(s);
      if (l)
        return n = setTimeout(O, t), y(s);
    }
    return n === void 0 && (n = setTimeout(O, t)), d;
  }
  return k.cancel = G, k.flush = M, k;
}
function I(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function ge(e) {
  return !!e && typeof e == "object";
}
function ve(e) {
  return typeof e == "symbol" || ge(e) && ue.call(e) == ee;
}
function S(e) {
  if (typeof e == "number")
    return e;
  if (ve(e))
    return L;
  if (I(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = I(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(te, "");
  var a = ne.test(e);
  return a || ae.test(e) ? ie(e.slice(2), a ? 2 : 8) : re.test(e) ? L : +e;
}
var be = me;
const he = /* @__PURE__ */ Q(be), W = K({});
function ye() {
  return w(W);
}
const Ce = ({
  render: e,
  onSaveDraft: t = () => "",
  onSubmitClick: a,
  onSubmit: r,
  debounceMs: i = 3e3,
  validateOnSubmit: f,
  ...d
}) => {
  const [n, s] = D(!1), v = q(he(t, i), [t, i]);
  return /* @__PURE__ */ p.jsx(
    V,
    {
      ...d,
      onSubmitClick: (m) => {
        s(!0), a == null || a(m);
      },
      onSubmit: (m, l) => {
        s(!0), r == null || r(m, l);
      },
      render: (m) => {
        const l = {
          ...m,
          hasAttemptedSubmit: n,
          saveDraft: t ? () => t(l.valueGetter("")) : void 0
        };
        return /* @__PURE__ */ p.jsx(W.Provider, { value: { formRenderProps: l, debouncedSaveDraft: v, validateOnSubmit: f }, children: e(l) });
      }
    }
  );
}, Ee = X, ke = ({ component: e, onChange: t, ...a }) => {
  const { debouncedSaveDraft: r, formRenderProps: i, validateOnSubmit: f } = ye();
  return /* @__PURE__ */ p.jsx(
    H,
    {
      ...a,
      onChange: (d) => {
        t == null || t(d), r == null || r(i.valueGetter(""));
      },
      hasAttemptedSubmit: i == null ? void 0 : i.hasAttemptedSubmit,
      validateOnSubmit: f,
      component: e
    }
  );
}, Ne = z, Ie = function(e) {
  return /* @__PURE__ */ p.jsxs(J, { ...e, children: [
    e.children,
    " ",
    e.required && /* @__PURE__ */ p.jsx("span", { className: "error-color", children: " *" })
  ] });
}, $e = T, _e = C, Pe = () => /* @__PURE__ */ p.jsx("span", { className: "k-form-separator" });
export {
  T as E,
  Ce as F,
  _e as H,
  $e as I,
  Ie as L,
  Ee as a,
  ke as b,
  Ne as c,
  Pe as d,
  W as e,
  H as f,
  ye as u
};
